import { AppShell } from '@/components/layout/AppShell';
import { useAuth } from '@/contexts/AuthContext';
import { AnimalDetailPage } from '@/pages/AnimalDetailPage';
import { AnimalsPage } from '@/pages/AnimalsPage';
import { BatchEventPage } from '@/pages/BatchEventPage';
import { BulkImportPage } from '@/pages/BulkImportPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { EventsPage } from '@/pages/EventsPage';
import { LotsPage } from '@/pages/LotsPage';
import { MovementsPage } from '@/pages/MovementsPage';
import { PropertyDetailPage } from '@/pages/PropertyDetailPage';
import { PropertiesPage } from '@/pages/PropertiesPage';
import { ReproductionPage } from '@/pages/ReproductionPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { SubscriptionPage } from '@/pages/SubscriptionPage';
import { SyncConflictsPage } from '@/pages/SyncConflictsPage';
import { ForgotPasswordPage } from '@/pages/auth/ForgotPasswordPage';
import { LoginPage } from '@/pages/auth/LoginPage';
import { RegisterPage } from '@/pages/auth/RegisterPage';
import { PrivacyPage } from '@/pages/legal/PrivacyPage';
import { TermsPage } from '@/pages/legal/TermsPage';
import { PublicSalePage } from '@/pages/sales/PublicSalePage';
import { SalesLeadsPage } from '@/pages/sales/SalesLeadsPage';
import { SalesLotDetailPage } from '@/pages/sales/SalesLotDetailPage';
import { SalesLotsPage } from '@/pages/sales/SalesLotsPage';
import { SalesReportPage } from '@/pages/sales/SalesReportPage';
import { IndicatorsDashboardPage } from '@/pages/indicators/IndicatorsDashboardPage';
import { DairyBatchPage } from '@/pages/dairy/DairyBatchPage';
import { DairyDashboardPage } from '@/pages/dairy/DairyDashboardPage';
import { DairyEntriesPage } from '@/pages/dairy/DairyEntriesPage';
import { DairyReportPage } from '@/pages/dairy/DairyReportPage';
import { Navigate, Outlet, createBrowserRouter } from 'react-router-dom';

function ProtectedRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-manejai-forest border-t-transparent" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  return <Outlet />;
}

function PublicOnlyRoute() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return <Outlet />;
}

export const router = createBrowserRouter([
  { path: '/termos', element: <TermsPage /> },
  { path: '/privacidade', element: <PrivacyPage /> },
  {
    element: <PublicOnlyRoute />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/esqueci-senha', element: <ForgotPasswordPage /> },
      { path: '/cadastro', element: <RegisterPage /> },
    ],
  },
  { path: '/s/:slug', element: <PublicSalePage /> },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppShell />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'propriedades', element: <PropertiesPage /> },
          { path: 'propriedades/:id', element: <PropertyDetailPage /> },
          { path: 'lotes', element: <LotsPage /> },
          { path: 'vendas', element: <SalesLotsPage /> },
          { path: 'vendas/relatorio', element: <SalesReportPage /> },
          { path: 'vendas/leads', element: <SalesLeadsPage /> },
          { path: 'vendas/:lotId', element: <SalesLotDetailPage /> },
          { path: 'animais', element: <AnimalsPage /> },
          { path: 'animais/:id', element: <AnimalDetailPage /> },
          { path: 'eventos', element: <EventsPage /> },
          { path: 'eventos-lote', element: <BatchEventPage /> },
          { path: 'pesagem-lote', element: <BatchEventPage /> },
          { path: 'movimentacoes', element: <MovementsPage /> },
          { path: 'reproducao', element: <ReproductionPage /> },
          { path: 'zootecnia', element: <IndicatorsDashboardPage /> },
          { path: 'controle-leiteiro', element: <DairyDashboardPage /> },
          { path: 'controle-leiteiro/lancamentos', element: <DairyEntriesPage /> },
          { path: 'controle-leiteiro/lote', element: <DairyBatchPage /> },
          { path: 'controle-leiteiro/relatorio', element: <DairyReportPage /> },
          { path: 'importacao', element: <BulkImportPage /> },
          { path: 'conflitos', element: <SyncConflictsPage /> },
          { path: 'configuracoes', element: <SettingsPage /> },
          { path: 'assinatura', element: <SubscriptionPage /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
